<template>
    <div class="row justify-center " style="min-width: 1200px;min-height: 95vh">
        <q-dialog position="right" v-model="dialog">
            <SchemePointHierarchy :date="currentDate" :isTeam="isTeam"
                                  :monthly-points="schemeDetail.minMonthlyPointsForEligible" @closeDialog="dialog=false"
                                  v-if="dialog"></SchemePointHierarchy>
        </q-dialog>
        <q-dialog persistent position="right" v-model="showReturnOrderHistory">
            <ReturnOrderHistory :partner-id="user.orgId" :scheme-id="schemeId"
                                @closeDialog="showReturnOrderHistory=false"></ReturnOrderHistory>
        </q-dialog>
        <q-dialog persistent position="right" v-model="showTransferHistory">
            <TransferHistory :partnerId="user.orgId" :schemeId="schemeId" :startDate="schemeDetail.startTime"
                             :endDate="schemeDetail.endTime" @closeDialog="showTransferHistory=false"/>
        </q-dialog>
        <div class="card q-pa-md">
            <div class="row">
                <div class="col-12">
                    <div class="drawerButtons float-right">
                        <q-btn @click="closeDialog" flat icon="close" round size="small"></q-btn>
                    </div>
                </div>
                <div class="col-4 q-pa-md">
                    <HeaderPoints :scheme-detail="schemeDetail"
                                  :scheme-enrollment-obj="schemeEnrollmentObj"></HeaderPoints>
                    <div class="mt-3" style="height: auto">
                        <div class="row">
                            <div class="col-12 my-2">
                                <SummaryPoints :scheme-detail="schemeDetail" :scheme-enrollment-obj="schemeEnrollmentObj"
                                               @showAdjustmentHistory="showAdjustmentHistory=true"
                                               @showReturnOrderHistory="showReturnOrderHistory=true"
                                               @showTransferHistory="showTransferHistory=true"/>
                            </div>
                            <div class="col-12 my-2">
                                <MyPoints :scheme-detail="schemeDetail"
                                          :scheme-enrollment-obj="schemeEnrollmentObj"></MyPoints>
                            </div>
                            <div class="col-12 my-2"
                                 v-if="isTeam">
                                <MyTeamPoints :scheme-detail="schemeDetail"
                                              :scheme-enrollment-obj="schemeEnrollmentObj"></MyTeamPoints>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8 q-pa-md">
                    <div class="row">
                        <div class="col-12">
                            <div class="row py-2">
                                <div class="col-2">Month</div>
                                <div class="col-2">My Eligible Points</div>
                                <div class="col-1" v-if="isTeam"></div>
                                <div class="col-3" v-if="isTeam">Team Eligible Points</div>
                                <div class="col-1" v-if="isTeam"></div>
                                <div class="col-3">Total Eligible Points</div>
                            </div>
                            <hr style="border: 0.5px solid #d9d9d9">
                        </div>
                        <div class="col-12" v-for="points in schemePoints">
                            <div @click="openDialog(points.month)" class="row py-2 point-row" style="cursor:pointer;">
                                <div class="col-2 py-2 pep-item " style="cursor: pointer">
                                    <span :class="'highlight-box-'+points.classApplied"
                                          class="pep-item-color d-block mx-auto"> {{points.month|monthFilter}}</span>
                                </div>
                                <div :class="'text-'+points.classApplied" class="col-2 py-2 pep-item">
                                    <span class="d-block mx-auto my-2">{{points.eligiblePoint?points.eligiblePoint:0}}</span>
                                </div>
                                <div class="col-1" v-if="isTeam">
                                    <i class="material-icons" style="font-size: 16px">
                                        add
                                    </i>
                                </div>
                                <div class="col-3 py-2 pep-item" v-if="isTeam"><span class="my-2 d-block">{{points.myTeamEligiblePoint?points.myTeamEligiblePoint:0}}</span>
                                </div>
                                <div class="col-1" v-if="isTeam">
                                    <i class="material-icons" style="font-size: 16px">
                                        drag_handle
                                    </i>
                                </div>
                                <div class="col-3 py-2 pep-item "><span class="d-block mx-auto my-2 total-point">{{points.eligiblePoint+points.myTeamEligiblePoint}}</span>
                                </div>
                            </div>
                            <hr style="border:  0.5px solid #eeeeee;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {GET_SCHEME_POINTS_DETAILS} from '../../graphql/queries/schemes'
    import moment from 'moment'
    import SchemePointHierarchy from './SchemePointHierarchy'
    import HeaderPoints from '../Common/HeaderPoints'
    import SummaryPoints from '../Common/SummaryPoints'
    import MyPoints from '../Common/MyPoints'
    import MyTeamPoints from '../Common/MyTeamPoints'
    import ReturnOrderHistory from "../ReturnOrder/ReturnOrderHistory";
    import TransferHistory from "./TransferHistory";

    export default {
        name: 'SchemePointDetail',
        components: {
            TransferHistory,
            ReturnOrderHistory, MyTeamPoints, MyPoints, SummaryPoints, HeaderPoints, SchemePointHierarchy},
        props: ['schemeId', 'isTeam', 'schemeDetail', 'schemeEnrollmentObj'],
        data() {
            return {
                user: JSON.parse(localStorage.getItem('user')),
                schemePoints: [],
                dialog: false,
                currentDate: moment().format('YYYY-MM-DD'),
                showAdjustmentHistory: false,
                showReturnOrderHistory: false,
                showTransferHistory: false,
            }
        },
        methods: {
            openDialog(month) {
                this.dialog = true
                this.currentDate = month
            },
            closeDialog() {
                this.$emit('closeDialog')
            },
        },
        apollo: {
            SchemePoints: {
                fetchPolicy: 'network-only',
                query: GET_SCHEME_POINTS_DETAILS,
                variables() {
                    return {
                        schemeId: this.schemeId,
                        partnerId: JSON.parse(localStorage.getItem('user')).organization.id,
                    }
                },
                result({data, loading}) {
                    if (!loading) {
                        localStorage.setItem('schemeId', this.schemeId)
                        this.schemePoints = data.SchemePoints
                        if (this.schemePoints) {
                            this.schemePoints.map(points => {
                                if (points.isEligible) {
                                    points.classApplied = 'green'
                                } else if (!points.isEligible && moment().format('YYYY-MM') ===
                                    moment(points.month, 'YYYY-MM-DD').format('YYYY-MM')) {
                                    points.classApplied = 'orange'
                                } else {
                                    points.classApplied = 'red'
                                }
                            })
                        }
                    }
                },
            },
        },
    }
</script>

<style scoped>

    .card {
        text-align: center;
        width: 100%;
        /*padding: 30px 40px;*/
        /*margin: auto;*/
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }
</style>
